// extracted by css-extract-rspack-plugin
export default {"rightCell":"right-cell--OzBY_lBsxSAYwd8e"};